import { IFormService } from "../../service/form/FormService";

export default class SendFormVersionInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formId: number) {
    return this.formService.sendFormVersion(formId);
  }
}
